module.exports = __webpack_public_path__ + "img/svg/position-3.975a83fc2799732183277a8efa239be5.svg";